MarketRate = window.MarketRate ?= require '../../../node_modules/market-rate-js/src/market-rate'

CITY_URL = "/travel/{{city_slug}}/hotels"
DESTINATION_URL = "/getaways"

Getaways = window.Getaways ?= {}
Getaways.SearchWidget ?= {}

Getaways.SearchWidget.init = (options, done) ->
  moment.locale(I18n.locale.replace("_", "-"))

  shouldShowTopSearchBar = options.searchWidget?.topSearch
  shouldShowBottomSearchBar = options.searchWidget?.bottomSearch
  searchConfig =
    formConfiguration:
      method: "GET"
      action: "action"

    searchConfiguration:
      cityUrl: CITY_URL
      destinationUrl: DESTINATION_URL
      urlBase: options.searchWidget?.urlBase

    eventCategories: ["change", "click"]
    views:
      seeMoreHotels : false
      destinationField: {}
      calendarSelection:
        daysLimit: 330
      autoComplete:
        resultsPerCategory: 10
      footer:
        searchText: ''
    localization:
      i18n: I18n.scoped('modules.getaways')

  if shouldShowTopSearchBar
    searchConfig.views.seeMoreHotels = true
    searchConfig.views.footer.searchText = 'search'
    searchViewTop = new MarketRate.Views.GallerySearch(searchConfig)
    searchViewTop.show $("#search-component-top")

  if shouldShowBottomSearchBar
    searchConfig.views.seeMoreHotels = false
    searchConfig.views.footer.searchText = 'search_getaways'
    searchViewBottom = new MarketRate.Views.GallerySearch(searchConfig)
    searchViewBottom.show $("#search-component-bottom")

  done()


module.exports = Getaways.SearchWidget
